export type schoolYear = '1º Ano Médio'
                       | '2º Ano Médio'
                       | '3º Ano Médio'
                       | 'Médio completo'
                       | '5º Ano Fundamental'
                       | '6º Ano Fundamental'
                       | '7º Ano Fundamental'
                       | '8º Ano Fundamental'
                       | '9º Ano Fundamental'
                       | 'Outro'
                       | '3ª Série'
                       | '2ª Série'
                       | '1ª Série'
                       | '8º ANO'
                       | '9º ANO'
                       | 'Multisseriada'
                       | 'PRE-VESTIBULAR'
                       | 'Extensivo'
                       | 'Semi 1º Semestre'
                       | 'Extracurricular'
                       | '6º ANO'
                       | '7º ANO';

export const schoolYearOptions: schoolYear[] = [
  '1º Ano Médio',
  '2º Ano Médio',
  '3º Ano Médio',
  'Médio completo',
  '5º Ano Fundamental',
  '6º Ano Fundamental',
  '7º Ano Fundamental',
  '8º Ano Fundamental',
  '9º Ano Fundamental',
  'Outro',
  '3ª Série',
  '2ª Série',
  '1ª Série',
  '8º ANO',
  '9º ANO',
  'Multisseriada',
  'PRE-VESTIBULAR',
  'Extensivo',
  'Semi 1º Semestre',
  'Extracurricular',
  '6º ANO',
  '7º ANO'
];
